import { Box } from "@mui/material";
import { useState } from "react";
import DashboardWidgetRenderer from "../configurations/dashboard-widgets/DashboardWidgetRenderer";

const OperationsDashboard = () => {
  const [selectedDate, setSelectedDate] = useState(new Date());


  return (
    <Box sx={{ minHeight: "100vh" }}>
      
      <DashboardWidgetRenderer
        dashboardKey="operations"
        widgetProps={{
          selectedDate,
          onDateSelect: setSelectedDate,
          crewMemberId: 23,
        }}
      />
    </Box>
  );
};

export default OperationsDashboard;